<template>
    <div class="c-stepper">
        <template v-if="!hideProgress">
            <ion-text color="dark">{{ value }} von {{ count }}</ion-text>
            <ion-progress-bar
                :value="value / count"
                class="ion-margin-bottom"
            ></ion-progress-bar>
        </template>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            required: true,
        },
        count: {
            type: Number,
            required: true,
        },
        hideProgress: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.c-stepper {
    position: relative;
}
</style>
